import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { createScriptElement, createStylesheetElement } from 'utils/dom/dom';

export const MicroFrontEndEmbed = ({ id, className, data, scriptURL, stylesheetURL, onLoad, onError }) => {
	useEffect(() => {
		const handleOnLoad = () => {
			// Build a config, inheriting the local config + any passed in properties
			if (onLoad) onLoad();
		};

		const handleOnError = () => {
			if (onError) onError();
		};

		if (stylesheetURL) {
			const linkEl = createStylesheetElement({
				id: `${id}-stylesheet`,
				href: stylesheetURL
			});

			document.head.appendChild(linkEl);

		} else {
			handleOnError();
			return;
		}

		const scriptEl = createScriptElement({
			id,
			src: scriptURL,
			onload: handleOnLoad,
			onerror: handleOnError,
			async: true,
			crossorigin: 'anonymous'
		});
		document.body.appendChild(scriptEl);
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	return <div className={className} id={id} {...data} />;
};

MicroFrontEndEmbed.propTypes = {
	className: PropTypes.string,
	id: PropTypes.string,
	data: PropTypes.object,
	scriptURL: PropTypes.string,
	stylesheetURL: PropTypes.string,
	onLoad: PropTypes.func,
	onError: PropTypes.func
};

export default MicroFrontEndEmbed;
